import {
  articleControlDayssaveOrModify, batchImport, batchSaveDC, fakeForInReceive, get, getArticlesByUuids, getArticlesByUuidsByDc, getByArticleCode, getByCodeAndCompanyUuid, getByDc, getByVendorUuid, getQpcsByArticleUuid,
  getQpcsByArticleUuidByDc, modify, offline, online, query, queryArticleWithKeyword,
  queryByBarcode, queryByUuids, queryWithKeyword, removeArticleBarcode, removeArticleDC, removeArticleQpc, removeArticleStorPrice, removeArticleVendor,
  removeStorePickQty,getBillArticlePrice,
  // getImportTemplateUrl,
  save, saveOrModifyArticleBarcode, saveOrModifyArticleDC, saveOrModifyArticleDcVendor, saveOrModifyArticleQpc, saveOrModifyArticleStorPrice, saveOrModifyArticleVendor,
  saveOrModifyStorePickQty
} from '@/services/basic/Article';
import { articleBusinessBatchImport } from '@/services/internal/article/ArticleBusiness';
import { formatMessage } from 'umi/locale';
export default {
  namespace: 'article',
  subscriptions: {
    /**
     * 监听浏览器地址
     * @param dispatch 触发器，用于触发 effects 中的 query 方法
     * @param history 浏览器历史记录，主要用到它的 location 属性以获取地址栏地址
     */
    setup({ dispatch, history }) {
      history.listen((location) => {
        if (location.payload && location.pathname == "/basic/article") {
          dispatch({
            type: 'showPage',
            payload: location.payload,
          })
        }
      });
    },
  },
  state: {
    data: {
      list: [],
      pagination: {},
    },
    entity: {},
    showPage: 'query',
    qpcs: [],
    articles: []
  },

  effects: {
    *query({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (response && response.success) {
        yield put({
          type: 'onQuery',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },

    *queryWithKeyword({ payload, callback }, { call, put }) {
      const response = yield call(queryWithKeyword, payload);

      if (response && response.success) {
        yield put({
          type: 'onQuery',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },
    *queryWithKeywordForSelect({ payload, callback }, { call, put }) {
      const response = yield call(queryWithKeyword, payload);
      if (callback) callback(response);
    },
    *queryArticleWithKeyword({ payload, callback }, { call, put }) {
      const response = yield call(queryArticleWithKeyword, payload);
      if (response && response.success) {
        yield put({
          type: 'onQuery',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },

    *get({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      if (response && response.success) {
        yield put({
          type: 'onView',
          payload: response.data
        });
      }
      if (callback) callback(response);
    },

    *getByDc({ payload, callback }, { call, put }) {
      const response = yield call(getByDc, payload);
      if (response && response.success) {
        yield put({
          type: 'onView',
          payload: response.data
        });
      }
      if (callback) callback(response);
    },

    * getArticlesByUuids({ payload, callback }, { call }) {
      const response = yield call(getArticlesByUuids, payload);
      if (callback) callback(response);
    },

    * getArticlesByUuidsByDc({ payload, callback }, { call }) {
      const response = yield call(getArticlesByUuidsByDc, payload);
      if (callback) callback(response);
    },

    //明细查询
    *getForItem({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      if (callback) callback(response);
    },

    *getBillArticlePrice({ payload, callback }, { call, put }) {
      const response = yield call(getBillArticlePrice, payload);
      if (callback) callback(response);
    },

    *queryByBarcode({ payload, callback }, { call, put }) {
      const response = yield call(queryByBarcode, payload);
      if (callback) callback(response);
    },

    *online({ payload, callback }, { call, put }) {
      const response = yield call(online, payload);
      if (callback) callback(response);
    },

    *offline({ payload, callback }, { call, put }) {
      const response = yield call(offline, payload);
      if (callback) callback(response);
    },

    *showPage({ payload }, { call, put }) {
      yield put({
        type: 'onShowPage',
        showPage: payload.showPage,
        entityUuid: payload.entityUuid,
        importType: payload.importType,
      });
    },

    *batchImport({ payload, callback }, { call, put }) {
      const response = yield call(batchImport, payload);
      if (callback) callback(response);
    },
    *articleBusinessBatchImport({ payload, callback }, { call, put }) {
      const response = yield call(articleBusinessBatchImport, payload);
      if (callback) callback(response);
    },
    *save({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (callback) callback(response);
    },

    *modify({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (callback) callback(response);
    },

    *saveOrModifyArticleQpc({ payload, callback }, { call, put }) {
      const response = yield call(saveOrModifyArticleQpc, payload);
      if (callback) callback(response);
    },

    *saveOrModifyArticleBarcode({ payload, callback }, { call, put }) {
      const response = yield call(saveOrModifyArticleBarcode, payload);
      if (callback) callback(response);
    },

    *saveOrModifyArticleVendor({ payload, callback }, { call, put }) {
      const response = yield call(saveOrModifyArticleVendor, payload);
      if (callback) callback(response);
    },

    *saveOrModifyStorePickQty({ payload, callback }, { call, put }) {
      const response = yield call(saveOrModifyStorePickQty, payload);
      if (callback) callback(response);
    },

    *saveOrModifyArticleStorPrice({ payload, callback }, { call, put }) {
      const response = yield call(saveOrModifyArticleStorPrice, payload);
      if (callback) callback(response);
    },

    *removeArticleQpc({ payload, callback }, { call, put }) {
      const response = yield call(removeArticleQpc, payload);
      if (callback) callback(response);
    },

    *removeArticleBarcode({ payload, callback }, { call, put }) {
      const response = yield call(removeArticleBarcode, payload);
      if (callback) callback(response);
    },

    *removeArticleVendor({ payload, callback }, { call, put }) {
      const response = yield call(removeArticleVendor, payload);
      if (callback) callback(response);
    },

    *removeArticleStorPrice({ payload, callback }, { call, put }) {
      const response = yield call(removeArticleStorPrice, payload);
      if (callback) callback(response);
    },

    *removeStorePickQty({ payload, callback }, { call, put }) {
      const response = yield call(removeStorePickQty, payload);
      if (callback) callback(response);
    },

    *getQpcsByArticleUuid({ payload, callback }, { call, put }) {
      const response = yield call(getQpcsByArticleUuid, payload);
      if (response && response.success) {
        yield put({
          type: 'onQueryQpcs',
          payload: response.data,
          articleUuid: payload.articleUuid
        });
      }
      if (callback) callback(response);
    },

    *getQpcsByArticleUuidByDc({ payload, callback }, { call, put }) {
      const response = yield call(getQpcsByArticleUuidByDc, payload);
      if (response && response.success) {
        yield put({
          type: 'onQueryQpcs',
          payload: response.data,
          articleUuid: payload.articleUuid
        });
      }
      if (callback) callback(response);
    },

    *fakeForInReceive({ payload, callback }, { call, put }) {
      const response = yield call(fakeForInReceive, payload);
      if (callback) callback(response);
    },
    *getByVendorUuid({ payload }, { call, put }) {
      const response = yield call(getByVendorUuid, payload);
      if (response && response.success) {
        yield put({
          type: 'onQueryArticles',
          payload: response.data
        });
      }
    },
    *queryByUuids({ payload, callback }, { call, put }) {
      const response = yield call(queryByUuids, payload);
      if (response && response.success) {
        yield put({
          type: 'onQueryArticles',
          payload: response.data
        });
      }

      if (callback) callback(response);
    },
    *saveOrModifyArticleDcVendor({ payload, callback }, { call, put }) {
      const response = yield call(saveOrModifyArticleDcVendor, payload);
      if (callback) callback(response);
    },
    *saveOrModifyArticleDC({ payload, callback }, { call, put }) {
      const response = yield call(saveOrModifyArticleDC, payload);
      if (callback) callback(response);
    },
    *removeArticleDC({ payload, callback }, { call, put }) {
      const response = yield call(removeArticleDC, payload);
      if (callback) callback(response);
    },
    *batchSaveDC({ payload, callback }, { call, put }) {
      const response = yield call(batchSaveDC, payload);
      if (callback) callback(response);
    },
    *getByCodeAndCompanyUuid({ payload, callback }, { call, put }) {
      const response = yield call(getByCodeAndCompanyUuid, payload);
      if (response && response.success) {
        yield put({
          type: 'onView',
          payload: response.data
        });
      }
      if (callback) callback(response);
    },
    *articleControlDayssaveOrModify({ payload, callback }, { call, put }) {
      const response = yield call(articleControlDayssaveOrModify, payload);
      if (callback) callback(response);
    },
    *getByArticleCode({ payload, callback }, { call, put }) {
      const response = yield call(getByArticleCode, payload);
      if (callback) callback(response);
    }
  },
  reducers: {
    onQuery(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },

    onQueryArticles(state, action) {
      return {
        ...state,
        articles: action.payload
      }
    },

    onQueryQpcs(state, action) {
      return {
        ...state,
        qpcs: action.payload,
        articleUuid: action.articleUuid
      };
    },

    onView(state, action) {
      return {
        ...state,
        entity: action.payload,
        entityUuid: action.payload.uuid
      }
    },

    onShowPage(state, action) {
      return {
        ...state,
        showPage: action.showPage,
        entityUuid: action.entityUuid,
        importType: action.importType,
      }
    }
  },
}
